<template>
  <div class="pr offices-box" :class="screenWidth<768 ? 'pl-20 pr-20' :''">
    <div class="wrapper">
      <el-row>
        <el-col v-for="(n, idx) in contactList" :key="idx" :span="24" class="offices-item">
          <div class="whitedark-bg mb-30 offices-item-img">
            <div
              :style="screenWidth>768?{backgroundImage: 'url('+ n.url + ')'}:{backgroundImage: 'url('+ n.mobile + ')'}"
              class="wi-100x ht-100x transition-lenear centerimage pr">
              <div v-observe-visibility="mapVisible" class="pa wi-100x ht-100x transition-slow tp-0 lf-0 whitedark-bg"></div>
            </div>
          </div>
          <el-row>
            <el-col :span="12" :xs="24">
              <div v-observe-visibility="infoVisible" class="pr bm--60 op-0 transition-gentle">
                <div class="serif offices-item-title black">{{n.position}}</div>
                <div class="wi-360 lh-26 offices-item-tags op-8">{{n.adress}}</div>
              </div>
            </el-col>
            <el-col :span="12" :xs="24">
              <div v-observe-visibility="infoVisible" class="ta-r pr bm--60 op-0 transition-gentle" :class="screenWidth>768?'ta-r':'ta-l'">
                <span @click="callPhone(n.phone)" :class="screenWidth<=1200?'title-default-text':'hover-text'" class="dis-ib serif offices-item-phone">{{n.phone}}</span>
                <div v-if="screenWidth<=768" class="dis-ib pr tp-8" @click="callPhone(n.phone)">
                  <!-- 两个是一样的避免同时出现导致第二个svg动画不动 -->
                  <fo-callPhoneSvg v-if="idx === 0"></fo-callPhoneSvg>
                  <fo-callPhoneSvg2 v-if="idx === 1"></fo-callPhoneSvg2>
                </div>
              </div>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'Offices',
  data () {
    return {
      contactList: []
    }
  },
  watch: {
    contactInfo (val) {
      if (val) {
        this.contactList = this.$.s2o(val)
        this.$.s('contactInfo', val)
      }
    }
  },
  computed: {
    ...mapGetters([
      'screenWidth'
    ])
  },
  mounted () {
    if (this.$.g('contactInfo')) {
      this.contactList = this.$.s2o(this.$.g('contactInfo'))
    }
  },
  methods: {
    /*
    * 调用拨电话
    */
    callPhone (phoneNumber) {
      window.location.href = 'tel:' + phoneNumber
    },
    infoVisible (isVisible, entity) {
      if (isVisible) {
        setTimeout(() => {
          entity.target.style.bottom = 0
          entity.target.style.opacity = 1
        }, 300)
      }
    },
    mapVisible (isVisible, entity) {
      if (isVisible) {
        entity.target.style.height = 0
      }
    }
  }
}
</script>
<style>
.offices-item-phone {
  font-size: 1.625em;
  font-weight: 600;
}
.offices-item-tags {
  font-size: 0.875em;
  margin-bottom: 20px;
}
.offices-item-title {
  font-size: 2em;
  font-weight: 600;
  margin-bottom: 2px;
}
.offices-item {
  margin-bottom: 5em;
}
.offices-box {
  margin-bottom: 2em;
}
.offices-item-img {
  height: 400px;
}
@media screen and (min-width: 768px) and (max-width: 992px) {
  .offices-item-phone {
    font-size: 28px;
    font-weight: 600;
  }
  .offices-item-tags {
    font-size: 15px;
    margin-bottom: 40px;
  }
  .offices-item-title {
    margin-bottom: 20px;
    font-size: 46px;
  }
  .offices-item {
    margin-bottom: 70px;
  }
  .offices-box {
    margin-bottom: 100px;
  }
  .offices-item-img {
    height: 600px;
  }
}
@media screen and (min-width: 992px) and (max-width: 1200px) {
  .offices-item-phone {
    font-size: 32px;
    font-weight: 600;
  }
  .offices-item-tags {
    font-size: 15px;
    margin-bottom: 40px;
  }
  .offices-item-title {
    margin-bottom: 20px;
    font-size: 56px;
  }
  .offices-item {
    margin-bottom: 80px;
  }
  .offices-box {
    margin-bottom: 120px;
  }
  .offices-item-img {
    height: 600px;
  }
}
@media screen and (min-width: 1200px) and (max-width: 1920px) {
  .offices-item-phone {
    font-size: 38px;
    font-weight: 600;
    position: relative;
    top: 10px;
  }
  .offices-item-tags {
    font-size: 14px;
    margin-bottom: 40px;
  }
  .offices-item-title {
    margin-bottom: 20px;
    font-size: 54px;
  }
  .offices-item {
    margin-bottom: 90px;
  }
  .offices-box {
    margin-bottom: 150px;
  }
  .offices-item-img {
    height: 600px;
  }
}
@media screen and (min-width: 1920px) {
  .offices-item-phone {
    font-size: 46px;
    font-weight: 600;
  }
  .offices-item-tags {
    font-size: 16px;
    margin-bottom: 40px;
  }
  .offices-item-title {
    margin-bottom: 20px;
    font-size: 76px;
  }
  .offices-item {
    margin-bottom: 100px;
  }
  .offices-box {
    margin-bottom: 180px;
  }
  .offices-item-img {
    height: 600px;
  }
}
</style>



// WEBPACK FOOTER //
// src/compos/Offices.vue